import { Component, OnInit } from '@angular/core';
import { IRendererEvent } from 'ngx3js';
import { LiquidLayer } from './view-warehouse-cylinder-multi/view-warehouse-cylinder-multi.component';
import { WarehousesComponent } from '../../configuration/inventory/warehouses/warehouses.component';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { InventoryService } from 'src/app/services/inventory.service';
import { ProductService } from 'src/app/services/product.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { ProductResponse } from 'src/app/models/product.model';
import { StatusWarehouseAllExistenceResponse, StatusWarehouseExistenceResponse } from 'src/app/models/inventory.model';
import { C } from '@fullcalendar/core/internal-common';

interface ContainerWarehouse {
  warehouse: WarehouseResponse;
  liquids: LiquidLayer[];
  percentageEmpty: number;
  data?: any;
}

@Component({
  selector: 'app-view-warehouse',
  templateUrl: './view-warehouse.component.html',
  styleUrls: ['./view-warehouse.component.scss']
})
export class ViewWarehouseComponent implements OnInit {
  warehouses: WarehouseResponse[] = [];
  products: ProductResponse[] = [];
  containers: ContainerWarehouse[] = [];
  user = null;

  inputs = {
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    },
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
        measurement: null
      }
    }
  };
  filterWarehouse: WarehouseResponse[] = [];
  filterProducts: ProductResponse[] = [];
  timeout = null;

  dataStatusWarehouse: StatusWarehouseExistenceResponse = null;
  dataStatusWarehouseAllExistence: StatusWarehouseAllExistenceResponse = null;
  liquidLayers: LiquidLayer[] = [];
  liquidLayersAll: LiquidLayer[] = [];

  constructor(
    private warehouseService: WarehouseService,
    private inventoryService: InventoryService,
    private productService: ProductService,
    private toastrService: ToastrService,
    private authService: AuthenticationService
  ) {
    this.user = authService.getUser();
  }

  ngOnInit(): void {
    this.getWarehouses();
    this.getProducts("");
    this.getStatusWarehouseAll();
  }

  getWarehouses() {
    this.warehouseService.getWarehousesAllowedByUserAndCylinder(this.user.id).subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouse = this.warehouses;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
      }
    })
  }

  getProducts(clue) {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data;
        this.filterProducts = this.products.filter((p) => {
          return p.type == "b"
        });

        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }
  writeProduct(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProducts(inputValue);
    }, 500);
  }

  checkProduct(product: ProductResponse) {
    this.inputs.product.class = "fa-circle-check";
    this.inputs.product.verified = true;
    this.inputs.product.data = product;
    this.inputs.product.value = product.name;
    this.getStatusWarehouse();
  }

  writeWarehouse(input) {
    const inputValue = input.target.value;

    this.filterWarehouse = this.warehouses.filter((w) =>
      w.name.toLowerCase().includes(inputValue.toLowerCase())
      || w.code.toLowerCase().includes(inputValue.toLowerCase())
    );

    if (this.filterWarehouse.length == 0) {
      this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
    } else if (this.filterWarehouse.length == 1) {
      this.changeInput(this.inputs.warehouse, this.filterWarehouse[0].name, true, null, 'fa-circle-check', this.filterWarehouse[0]);
    } else {
      this.changeInput(this.inputs.warehouse, input.target.value, false, null, 'fa-list', null);
    }
  }

  checkWarehouse(warehouse: WarehouseResponse) {
    this.inputs.warehouse.class = "fa-circle-check";
    this.inputs.warehouse.verified = true;
    this.inputs.warehouse.data = warehouse;
    this.inputs.warehouse.value = warehouse.name;
    this.getStatusWarehouse();
  }

  getStatusWarehouseAll() {

    this.inventoryService.getAllWarehouseAndAllProductExistences(1).subscribe({
      next: (response: ResponseObject) => {
        this.dataStatusWarehouseAllExistence = response.data;
        this.generateLiquidsAll();
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al consultar estado general de las bodegas");
      }
    })
  }

  getStatusWarehouse() {
    if (!this.inputs.warehouse.verified || !this.inputs.product.verified) {
      return;
    }

    const idWarehouse = this.inputs.warehouse.data.id;
    const idProduct = this.inputs.product.data.id;

    this.inventoryService.getWarehouseAndProductExistences(idWarehouse, idProduct).subscribe({
      next: (response: ResponseObject) => {
        this.dataStatusWarehouse = null
        this.dataStatusWarehouse = response.data;
        this.setLiquid();
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al consultar estado de la bodega");
      }
    })
  }

  setLiquid() {
    this.containers = [];
    if (this.dataStatusWarehouse == null)
      return;

    this.liquidLayers = [];


    this.dataStatusWarehouse.details.forEach(detail => {
      const percentage = detail.percentage;
      const liquid: LiquidLayer = {
        color: detail.belongsToType == 1 ? '#00E300' : '#FFFF00',
        percentage: percentage,
        waveParams: [{ height: 0.05, frequency: 5, speed: 2 }],
        label: detail.belongsTo
      }

      this.liquidLayers.push(liquid);
    });
  }

  generateLiquidsAll() {
    if (this.dataStatusWarehouseAllExistence != null) {
      this.dataStatusWarehouseAllExistence.details.sort(
        (a, b) => a.warehouse.name.localeCompare(b.warehouse.name, 'es', { sensitivity: 'base' })
      );

      this.dataStatusWarehouseAllExistence.details.forEach(detail => {
        const percentage = detail.percentageWarehouse;
        const liquid: LiquidLayer = {
          color: detail.colorHex,
          percentage: percentage,
          waveParams: [{ height: 0.05, frequency: 5, speed: 2 }],
          label: detail.warehouse.name
        }

        this.liquidLayersAll.push(liquid);
      });
    }
  }

  setLiquids() {
    this.containers = [];
    this.warehouses.forEach(element => {
      if (element.type != 1 && element.type != 2)
        return;

      if (element.type == 1) {
        const containerWarehouse: ContainerWarehouse = {
          warehouse: element,
          liquids: [
            { color: '#00E300', percentage: 0.3, waveParams: [{ height: 0.05, frequency: 4, speed: 2 }], label: "Nosotros" },
            { color: '#FFFF00', percentage: 0.13, waveParams: [{ height: 0.05, frequency: 4, speed: 2 }], label: "Maquila" },
          ],
          percentageEmpty: (0.3 + 0.13)
        }
        this.containers.push(containerWarehouse);
      }

      if (element.type == 2) {
        const containerWarehouse: ContainerWarehouse = {
          warehouse: element,
          liquids: [
            { color: '#00E300', percentage: 0.4, waveParams: [{ height: element.height * 0.01, frequency: 4, speed: 4 }], label: "Nosotros" },
            { color: '#FFFF00', percentage: 0.13, waveParams: [{ height: element.height * 0.01, frequency: 4, speed: 4 }], label: "Maquila" },
          ],
          percentageEmpty: (0.3 + 0.13)
        }
        this.containers.push(containerWarehouse);
      }
    });
  }

  get totalPercentage() {
    let total = 0;
    if (this.dataStatusWarehouseAllExistence != null) {
      this.dataStatusWarehouseAllExistence.details.forEach(element => {
        total += element.percentageWarehouse;
      });
    }
    return Math.ceil(total);
  }
}
